module.exports = __webpack_public_path__ + "static/media/Datasets.438e9be2.svg";